import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const rollbar = defineConnector({
  identifier: "rollbar",
  name: "Rollbar",
  tagLine: "Error tracking and monitoring",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: () => "https://api\\.rollbar\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "X-Rollbar-Access-Token", value: app.secret.accessToken },
    ]),
  steps: [
    {
      title: "Create a project access token",
      items: [
        {
          kind: "markdown",
          content:
            "In [Rollbar](https://rollbar.com/), open your project’s **Settings › Project Access Tokens** and create a token with **read** scope.",
        },
      ],
    },
    {
      title: "Paste your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.rollbar.com/api/1/items",
  },
});
